import { EmptyState } from '@app/components/base/EmptyState';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const bcrMatchesReportEmptyHelp = defineMessage({
  id: 'audit.bcrMatchesReport.emptyState.help',
  defaultMessage:
    'Compara los logs BCR importados con los matches del sistema para el día seleccionado. Permite verificar qué emisiones del log externo fueron confirmadas y cuáles no.',
});

/**
 * Placeholder shown before the first BCR matches report run, explaining what the report calculates.
 */
export function BcrMatchesReportEmptyState() {
  return (
    <EmptyState
      icon={FactCheckOutlinedIcon}
      message={false}
      help={<FormattedMessage {...bcrMatchesReportEmptyHelp} />}
    />
  );
}
